import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "grid grid-cols-3 gap-8 w-full" }
const _hoisted_4 = { class: "inputTitle" }
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = ["max"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "flex-grow" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "inputTitle" }
const _hoisted_12 = { class: "flex-grow" }
const _hoisted_13 = ["max"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "inputTitle" }
const _hoisted_16 = { class: "flex-grow" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "inputTitle" }
const _hoisted_19 = { class: "flex-grow" }
const _hoisted_20 = ["max"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "inputTitle" }
const _hoisted_23 = { class: "flex-grow" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "inputTitle" }
const _hoisted_26 = { class: "flex-grow" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "inputTitle" }
const _hoisted_29 = { class: "flex-grow" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "inputTitle" }
const _hoisted_32 = { class: "flex-grow" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "inputTitle" }
const _hoisted_35 = { class: "flex-grow" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "inputTitle" }
const _hoisted_38 = { class: "flex-grow" }
const _hoisted_39 = ["max"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { class: "inputTitle" }
const _hoisted_42 = { class: "flex-grow" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "mt-7" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "text-center" }

import {onMounted, ref} from "vue";
import TextOrSpinner from "@/components/TextOrSpinner.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ConfigService from "@/utilities/services/entities/ConfigService";
import Error from "@/components/Error.vue";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import ServiceConfig from "@/models/entities/ServiceConfig";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";



export default /*#__PURE__*/_defineComponent({
  __name: 'Configuration',
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();

const configService = new ConfigService();
const pageIsLoading = ref<boolean>(false);
const loadingConfirm = ref<boolean>(false);

const config = ref<ServiceConfig>(new ServiceConfig());

const loadConfig = async()=> {
  const resp = await configService.get(ErrorLocationType.table);
  if(!resp) return;
  config.value = resp;
}

const updateConfig = async()=> {
  loadingConfirm.value = true;
  const resp = await configService.update(config.value, ErrorLocationType.table);
  if(!resp) return;
  loadingConfirm.value = false;

  globalStore.showSuccess(t("general.saved"))
}

onMounted(async ()=> {
  pageIsLoading.value = true;
  await loadConfig();
  pageIsLoading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("configuration.title")), 1)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('configuration.fileDeletionDefault')), 1),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              max: config.value.daysToDeleteFilesMax,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((config.value.daysToDeleteFileDefault) = $event))
            }, null, 8, _hoisted_6), [
              [_vModelText, config.value.daysToDeleteFileDefault]
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('configuration.fileDeletionMax')), 1),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((config.value.daysToDeleteFilesMax) = $event))
            }, null, 512), [
              [_vModelText, config.value.daysToDeleteFilesMax]
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('configuration.ticketDeletionDefault')), 1),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              max: config.value.daysToDeleteUnusedTicketsMax,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((config.value.daysToDeleteUnusedTicketsDefault) = $event))
            }, null, 8, _hoisted_13), [
              [_vModelText, config.value.daysToDeleteUnusedTicketsDefault]
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('configuration.ticketDeletionMax')), 1),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((config.value.daysToDeleteUnusedTicketsMax) = $event))
            }, null, 512), [
              [_vModelText, config.value.daysToDeleteUnusedTicketsMax]
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('configuration.ticketLifespanDefault')), 1),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              max: config.value.daysToBeValidForTicketsMax,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((config.value.daysToBeValidForTicketsDefault) = $event))
            }, null, 8, _hoisted_20), [
              [_vModelText, config.value.daysToBeValidForTicketsDefault]
            ]),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('configuration.ticketLifespanMax')), 1),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((config.value.daysToBeValidForTicketsMax) = $event))
            }, null, 512), [
              [_vModelText, config.value.daysToBeValidForTicketsMax]
            ]),
            _hoisted_24
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('configuration.logLifespan')), 1),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((config.value.daysToKeepLogs) = $event))
            }, null, 512), [
              [_vModelText, config.value.daysToKeepLogs]
            ]),
            _hoisted_27
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('configuration.fileLogLifespan')), 1),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((config.value.daysToKeepFileLogs) = $event))
            }, null, 512), [
              [_vModelText, config.value.daysToKeepFileLogs]
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('configuration.otpLifespan')), 1),
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((config.value.hoursForOTPToBeValid) = $event))
            }, null, 512), [
              [_vModelText, config.value.hoursForOTPToBeValid]
            ]),
            _hoisted_33
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('configuration.deletionReminder')), 1),
          _createElementVNode("div", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((config.value.daysToRemindBeforeDeletion) = $event))
            }, null, 512), [
              [_vModelText, config.value.daysToRemindBeforeDeletion]
            ]),
            _hoisted_36
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('configuration.defaultAttempts')), 1),
          _createElementVNode("div", _hoisted_38, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              max: config.value.limitOfAttempts,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((config.value.defaultOfAttempts) = $event))
            }, null, 8, _hoisted_39), [
              [_vModelText, config.value.defaultOfAttempts]
            ]),
            _hoisted_40
          ]),
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('configuration.limitAttempts')), 1),
          _createElementVNode("div", _hoisted_42, [
            _withDirectives(_createElementVNode("input", {
              class: "bg-transparent w-full",
              type: "number",
              min: "0",
              step: "1",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((config.value.limitOfAttempts) = $event))
            }, null, 512), [
              [_vModelText, config.value.limitOfAttempts]
            ]),
            _hoisted_43
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("button", {
          disabled: loadingConfirm.value,
          class: "primary ml-auto",
          onClick: updateConfig
        }, [
          _createVNode(TextOrSpinner, {
            text: _ctx.$t('general.save'),
            spin: loadingConfirm.value
          }, null, 8, ["text", "spin"])
        ], 8, _hoisted_45)
      ])
    ], 512), [
      [_vShow, !pageIsLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_46, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, pageIsLoading.value]
    ])
  ], 64))
}
}

})